import { Controller } from '@hotwired/stimulus';
import Redactor from '../admin/redactor/redactor.min';
import '../admin/redactor/plugins';

export default class RedactorController extends Controller {
  static values = {
    hideDeleteLink: Boolean
  }

  connect () {
    this.initializeEditors();
    this.hideDeleteLinks();

    // Re-initialize on dynamically added content
    document.addEventListener('has_many_add:after', () => {
      this.initializeEditors();
      this.hideDeleteLinks();
    });
  }

  initializeEditors() {
    const csrfToken = document.querySelector('meta[name=csrf-token]')?.content;
    const csrfParam = document.querySelector('meta[name=csrf-param]')?.content;
    const csrf = csrfToken && csrfParam ? `${csrfParam}=${encodeURIComponent(csrfToken)}` : '';
    const imageUploadURL = `/redactor/image_upload?${csrf}`;

    this.element.querySelectorAll('.redactor').forEach((el) => {
      if (!el._redactorInitialized) {
        Redactor(el, {
          plugins: ['fontcolor', 'fontsize', 'alignment', 'fullscreen', 'table', 'video', 'googleMapsPlugin'],
          buttons: [
            'format', 'redo', 'undo', 'fontcolor', 'fontsize', 'bold', 'italic', 'underline', 'deleted',
            'lists', 'table', 'image', 'link', 'alignment', 'html', 'video', 'googlemaps'
          ],
          formatting: ['p', 'blockquote', 'h2', 'h3', 'h4'],
          imageUpload: imageUploadURL,
          imagePosition: true,
          imageResizable: true,
          lang: 'fr'
        });
        el._redactorInitialized = true;
      }
    });

    this.element.querySelectorAll('.redactor-banner').forEach((el) => {
      if (!el._redactorInitialized) {
        Redactor(el, {
          plugins: ['fontcolor', 'fontsize', 'alignment', 'fullscreen', 'table'],
          buttons: [
            'format', 'redo', 'undo', 'fontcolor', 'fontsize', 'bold', 'italic', 'underline', 'deleted',
            'lists', 'table', 'image', 'link', 'alignment'
          ],
          formatting: ['p', 'blockquote'],
          imageUpload: imageUploadURL,
          imagePosition: true,
          imageResizable: true,
          lang: 'fr'
        });
        el._redactorInitialized = true;
      }
    });
  }

  // Need to remove Active Admin has many delete links after rendering
  // because for the moment AA doesn't give native option to do it
  hideDeleteLinks() {
    if (!this.hideDeleteLinkValue) return;

    this.element.querySelectorAll('.has-many-remove').forEach(link => {
      link.remove();
    });
  }
}
